import {
  LinkSVG,
  ShareSVG,
  TelegramSVG,
  VkSVG,
} from '@sbercloud/uikit-product-icons';
import { ButtonFunction } from '@snack-uikit/button';
import { Droplist, DroplistProps } from '@snack-uikit/list';
import { useAnalytics } from 'src/hooks/useAnalytics';

type DropdownShareProps = {
  hideLabel?: boolean;
};

export function DropdownShare(props: DropdownShareProps) {
  const { hideLabel } = props;

  const { clickAnalytics } = useAnalytics();

  const items: DroplistProps['items'] = [
    {
      id: 'telegram',
      content: { option: 'Telegram' },
      beforeContent: <TelegramSVG />,
      onClick: () => {
        clickAnalytics({
          action: `https://telegram.me/share/url?url=${globalThis.location.href}`,
          clickContent: 'Telegram',
          clickElement: 'button',
          clickZone: 'body',
          clickZoneCategory: 'site-body',
          transitionType: 'inside-link',
          uniqueId: 'article-share-telegram',
          transitionTypeMetrics: 'internal',
          transitionUrl: `https://telegram.me/share/url?url=${globalThis.location.href}`,
        });

        return globalThis.window.open(
          `https://telegram.me/share/url?url=${globalThis.location.href}`,
        );
      },
    },
    {
      id: 'vk',
      content: { option: 'VK' },
      beforeContent: <VkSVG />,
      onClick: () => {
        clickAnalytics({
          action: `https://vk.com/share.php?url=${globalThis.location.href}`,
          clickContent: 'VK',
          clickElement: 'button',
          clickZone: 'body',
          clickZoneCategory: 'site-body',
          transitionType: 'inside-link',
          uniqueId: 'article-share-VK',
          transitionTypeMetrics: 'internal',
          transitionUrl: `https://vk.com/share.php?url=${globalThis.location.href}`,
        });

        return globalThis.window.open(
          `https://vk.com/share.php?url=${globalThis.location.href}`,
        );
      },
    },
    {
      id: 'copy',
      content: { option: 'Копировать ссылку' },
      beforeContent: <LinkSVG />,
      onClick: () => {
        clickAnalytics({
          action: 'click',
          clickContent: 'Копировать ссылку',
          clickElement: 'button',
          clickZone: 'body',
          clickZoneCategory: 'site-body',
          transitionType: 'inside-link',
          uniqueId: 'article-copy-link',
        });

        return globalThis.navigator.clipboard.writeText(
          globalThis.location.href,
        );
      },
    },
  ];

  return (
    <Droplist items={items} size="l" closeDroplistOnItemClick>
      <ButtonFunction
        size="m"
        label={!hideLabel ? 'Поделиться' : undefined}
        icon={<ShareSVG />}
        data-test-id="dropdown-share-button"
      />
    </Droplist>
  );
}
